import { HocuspocusProvider } from "@hocuspocus/provider";
// import UniqueID from "@tiptap-pro/extension-unique-id";
import { Extensions, Node } from "@tiptap/core";
// import BulletList from "@tiptap/extension-bullet-list";
import Collaboration, { isChangeOrigin } from "@tiptap/extension-collaboration";
import { Color } from "@tiptap/extension-color";
import Link from "@tiptap/extension-link";
// import ListItem from "@tiptap/extension-list-item";
import TextStyle from "@tiptap/extension-text-style";
import { Plugin } from "@tiptap/pm/state";
import StarterKit from "@tiptap/starter-kit";
import { nanoid } from "nanoid";
import * as Y from "yjs";

import BulletList from "./BulletList";
import CollaborationCursor from "./CollaborationCursor";
import CoordinationListItem from "./CoordinationListItem";
import ListItem from "./ListItem";
import RoadmapListItem from "./RoadmapList";
import UniqueID from "./UniqueID";

// import { UniqueId } from "./UniqueId";

// 2. Overwrite the keyboard shortcuts
const CustomBulletList = BulletList.extend({
  addKeyboardShortcuts() {
    return {
      Tab: () => {
        this.editor
          .chain()
          .sinkListItem("listItem")
          // .command(({ tr }) => {
          //   tr.insertText(" ");

          //   return true;
          // })
          .run();

        return true; // <- make sure to return true to prevent the tab from blurring.
      },
    };
  },
});

// Thanks flaviouk
// https://github.com/ueberdosis/tiptap/issues/1041#issuecomment-917610594
const SyncedBlockId = Node.create({
  name: "syncedBlockId",

  addGlobalAttributes() {
    return [
      // {
      //   types: ["paragraph", "bulletList", "listItem"],
      //   attributes: {
      //     blockId: {
      //       default: null,
      //       rendered: true,
      //       keepOnSplit: false,
      //     },
      //   },
      // },
      {
        types: ["listItem"],
        attributes: {
          syncedBlockId: {
            default: null,
            rendered: true,
            keepOnSplit: false,
          },
          syncedBlockProject: {
            default: null,
            rendered: true,
            keepOnSplit: false,
          },
        },
      },
    ];
  },

  // addProseMirrorPlugins() {
  //   return [
  //     new Plugin({
  //       appendTransaction: (_transactions, oldState, newState) => {
  //         // no changes
  //         if (newState.doc === oldState.doc) {
  //           return;
  //         }
  //         const tr = newState.tr;

  //         newState.doc.descendants((node, pos, parent) => {
  //           if (!node.attrs.blockId && node.type.name != "text") {
  //             tr.setNodeMarkup(pos, undefined, {
  //               ...node.attrs,
  //               blockId: nanoid(),
  //             });
  //           }
  //         });

  //         return tr;
  //       },
  //     }),
  //   ];
  // },
});

export const loadExtensions = (provider?: HocuspocusProvider, ydoc?: Y.Doc, readOnly = false) => {
  const extensions: Extensions = [
    Color.configure({ types: [TextStyle.name, RoadmapListItem.name] }),
    TextStyle,
    SyncedBlockId,
    // UniqueID.configure({
    //   attributeName: "blockId",
    //   types: ["listItem"],
    //   generateID: () => nanoid(),
    //   filterTransaction: (transaction) => !isChangeOrigin(transaction),
    // }),
    Link.configure({
      // openOnClick: false,
    }),
    // SyncedNodeSlashCommand.configure({}),
  ];

  // Register collaboration if set
  if (ydoc && provider) {
    extensions.push(StarterKit.configure({ history: false }));
    extensions.push(Collaboration.configure({ document: ydoc }));
    if (!readOnly) extensions.push(CollaborationCursor.configure({ provider }));

    // Otherwise just add starter kit
  } else {
    extensions.push(StarterKit.configure({}));
  }

  extensions.push(BulletList);
  extensions.push(CoordinationListItem);

  return extensions;
};
